export class FiltroOpcao {
    public valor: string;
    public texto: string;
}